function FinancialReports({ message, message2 }) {
  return (
    <div className="p-6 w-1/3 h-48">
      <h2 className="text-3xl text-center mt-4 mx-auto text-neutral-700">
        Asistente
      </h2>
      <h2 className="text-3xl text-center mt-12 mb-4 mx-auto text-neutral-700">
        Guias <span className="font-bold">de Apoyo</span>
      </h2>
    </div>
  );
}

export default FinancialReports;
